export default __webpack_public_path__ + "static/media/signomas.916fd28b.svg";